import React from "react";

const ForeignKeySelectorInt: React.FC<{}> = () => {
  return null;
};

export default ForeignKeySelectorInt;
